import { css } from '@emotion/react';
import { UIColorPalette } from './ColorPalette';

export function formatDuration(milliseconds: number) {
  var seconds = milliseconds / 1000;
  var hours = Math.floor(seconds / (60 * 60));
  var minutes = Math.floor(seconds / 60) % 60;
  seconds = Math.floor(seconds) % 60;

  var ret = '';
  if (hours) {
    ret += hours + ':';
  }
  if (minutes < 10) {
    ret += '0';
  }
  ret += minutes + ':';
  if (seconds < 10) {
    ret += '0';
  }
  ret += seconds;
  return ret;
}

export function FinishPosition(props: {
  position: number;
  className?: string;
  style?: React.CSSProperties;
}) {
  const positionString = formatFinishPosition(props.position);
  return (
    <span
      css={
        PositionToCSS[props.position as keyof typeof PositionToCSS] ||
        PositionToCSS.default
      }
      className={props.className}
      style={props.style}
    >
      {positionString}
    </span>
  );
}

const PositionToCSS = {
  1: css({
    fontWeight: 'bold',
    color: UIColorPalette.leaderboardGold,
  }),
  2: css({
    fontWeight: 'bold',
    color: UIColorPalette.leaderboardSilver,
  }),
  3: css({
    fontWeight: 'bold',
    color: UIColorPalette.leaderboardBronze,
  }),
  default: css({
    color: UIColorPalette.leaderboardPositionText,
  }),
};

export function formatFinishPosition(position: number) {
  if (position === 1) {
    return '1st';
  } else if (position === 2) {
    return '2nd';
  } else if (position === 3) {
    return '3rd';
  } else {
    return `${position}th`;
  }
}
